import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Image from 'next/image';
import { FC } from 'react';
import Styles from './HouseServicesCardItem.module.scss';
import Badges from '@/components/UI/badges/Badges';
type Props = {
  item: any;
};
const meals = ['breakfast', 'lunch', 'dinner'];
const HouseServicesCardItem: FC<Props> = ({
  item
}) => {
  return <Box className={Styles['item']} data-sentry-element="Box" data-sentry-component="HouseServicesCardItem" data-sentry-source-file="HouseServicesCardItem.tsx">
      <Box className={Styles['top-content']} data-sentry-element="Box" data-sentry-source-file="HouseServicesCardItem.tsx">
        <Box className={Styles['right-section']} data-sentry-element="Box" data-sentry-source-file="HouseServicesCardItem.tsx">
          <Image src={item.icon_url} alt={item.icon_url} width={24} height={24} data-sentry-element="Image" data-sentry-source-file="HouseServicesCardItem.tsx" />
          <Typography variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="HouseServicesCardItem.tsx">
            {item.feature_label || item.title}
          </Typography>
        </Box>
        <Box className={Styles['badge']} data-sentry-element="Box" data-sentry-source-file="HouseServicesCardItem.tsx">
          {meals.includes(item.feature_name) && <Badges label={item.meta_data?.is_free ? 'رایگان' : 'هزینه دارد'} type="default" />}
        </Box>
      </Box>
      <Box data-sentry-element="Box" data-sentry-source-file="HouseServicesCardItem.tsx">
        <Typography variant="bodyM" color="secondary_main" className={Styles['description']} data-sentry-element="Typography" data-sentry-source-file="HouseServicesCardItem.tsx">
          {item?.description}
        </Typography>
      </Box>
    </Box>;
};
export default HouseServicesCardItem;